import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/images/pay.png'
import _imports_1 from '../campaigns/assets/images/syndycampaign.png'
import _imports_2 from '../campaigns/assets/images/upload-content.svg'
import _imports_3 from '@/assets/images/copy-icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-10c70198"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-grid p-col-12" }
const _hoisted_2 = { class: "p-d-flex p-flex-column p-ai-center p-p-6 p-m-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "send-payment" }, "Payment Sent", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "p-mt-6 p-mb-6"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "payment-color" }, "Your payment was successfully sent by the client", -1))
const _hoisted_6 = { class: "p-mt-4" }
const _hoisted_7 = { class: "p-text-bold" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons no-items-icon" }, "arrow_back_ios ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-between p-col-12" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Your Submission")
], -1))
const _hoisted_10 = { class: "p-d-flex p-justify-between submission-details" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign", -1))
const _hoisted_12 = { class: "p-d-flex" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 1,
  class: "brand-pic",
  src: _imports_1
}
const _hoisted_15 = { class: "p-flex-column p-ml-4" }
const _hoisted_16 = { class: "campaign-name" }
const _hoisted_17 = { class: "p-d-flex" }
const _hoisted_18 = ["src"]
const _hoisted_19 = {
  class: "p-ml-2 p-mt-2",
  style: {"font-style":"normal","font-weight":"600","font-size":"12px","line-height":"15px","color":"#162020"}
}
const _hoisted_20 = {
  key: 0,
  class: "p-flex-column adaptive-column"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign CPI", -1))
const _hoisted_22 = { class: "p-mt-lg-6 p-mt-md-2" }
const _hoisted_23 = { class: "default-text" }
const _hoisted_24 = {
  key: 1,
  class: "p-flex-column adaptive-column"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign CPC", -1))
const _hoisted_26 = { class: "p-mt-lg-6 p-mt-md-2" }
const _hoisted_27 = { class: "default-text" }
const _hoisted_28 = {
  key: 2,
  class: "p-flex-column adaptive-column"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign CPM", -1))
const _hoisted_30 = { class: "p-mt-lg-6 p-mt-md-2" }
const _hoisted_31 = { class: "default-text" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = { class: "default-text" }
const _hoisted_34 = { class: "p-flex-column adaptive-column" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Campaign Period", -1))
const _hoisted_36 = { class: "p-mt-lg-6 p-mt-md-2" }
const _hoisted_37 = { class: "default-text" }
const _hoisted_38 = { class: "p-flex-column" }
const _hoisted_39 = { class: "p-mt-4" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-between p-col-12 p-mt-6" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Your Participation")
], -1))
const _hoisted_41 = {
  class: "p-d-flex p-justify-center p-flex-wrap p-align-left p-mt-4 w-100",
  style: {"gap":"30px"}
}
const _hoisted_42 = { class: "p-flex-column column-box" }
const _hoisted_43 = { class: "img-upload-container" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "upload-image",
  src: _imports_2
}, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "p-mt-4" }, "Upload New Content", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Upload a link and leave a comment to submit your content", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-col-12 p-mt-6 w-100" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Your Content")
], -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("template", null, null, -1))
const _hoisted_49 = { class: "p-d-flex main-name-block" }
const _hoisted_50 = ["src"]
const _hoisted_51 = { class: "link p-d-flex" }
const _hoisted_52 = { class: "link-bold eclipsis" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = { class: "campaign-name" }
const _hoisted_55 = { class: "campaign-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_NotificationTip = _resolveComponent("NotificationTip")!
  const _component_submission_modal = _resolveComponent("submission-modal")!
  const _component_Button = _resolveComponent("Button")!
  const _component_tracking_link = _resolveComponent("tracking-link")!
  const _component_overlay_panel_modal = _resolveComponent("overlay-panel-modal")!
  const _component_Column = _resolveComponent("Column")!
  const _component_status_chip = _resolveComponent("status-chip")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_Dialog, {
      header: " ",
      visible: $setup.openModal,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (($setup.openModal) = $event)),
      style: { width: '25vw' },
      modal: true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", {
          label: "OK  q",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openModal = !$setup.openModal)),
          class: "p-button-text red-button succes-pay-btn"
        }, "OK")
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("p", _hoisted_6, [
            _createTextVNode(" Yaayy! Your payment ("),
            _createElementVNode("span", _hoisted_7, _toDisplayString($setup.contract?.contracts[0]?.price) + " USD", 1),
            _createTextVNode(") was successfully sent by the client ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createElementVNode("div", {
      class: "p-mt-4 back p-col-12",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.go(-1)))
    }, [
      _hoisted_8,
      _createTextVNode(" Back to Campaigns ")
    ]),
    _hoisted_9,
    ($setup.contract?.contracts[0]?.status === 'payment')
      ? (_openBlock(), _createBlock(_component_NotificationTip, {
          key: 0,
          status: 'success'
        }))
      : _createCommentVNode("", true),
    ($setup.contract?.contracts[0]?.status === 'archive')
      ? (_openBlock(), _createBlock(_component_NotificationTip, {
          key: 1,
          status: 'archived'
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", null, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", null, [
            ($setup.contract?.photo?.length > 0)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "brand-pic",
                  src: $setup.contract?.photo
                }, null, 8, _hoisted_13))
              : (_openBlock(), _createElementBlock("img", _hoisted_14))
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("h4", _hoisted_16, _toDisplayString($setup.contract?.name), 1),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  style: {"width":"26px","height":"26px","background":"rgba(232, 232, 232, 0.34)","border-radius":"20px"},
                  src: $setup.contract?.brand?.photo
                }, null, 8, _hoisted_18)
              ]),
              _createElementVNode("div", _hoisted_19, _toDisplayString($setup.contract?.brand?.name), 1)
            ])
          ])
        ])
      ]),
      ($setup.contract?.paymentMethod === $setup.CampaignPaymentMethod.CPI)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("span", _hoisted_23, _toDisplayString($setup.calculateCpiRate($setup.contract?.cpi?.ios?.amount, $setup.contract?.appliedFee)) + " " + _toDisplayString($setup.contract?.budget?.currency), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.contract?.paymentMethod === $setup.CampaignPaymentMethod.CPC)
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("span", _hoisted_27, _toDisplayString($setup.calculateCpiRate($setup.contract?.cpc?.amount, $setup.contract?.appliedFee)) + " " + _toDisplayString($setup.contract?.budget?.currency), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      ($setup.contract?.paymentMethod === $setup.CampaignPaymentMethod.CPM)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("span", _hoisted_31, " Amount: " + _toDisplayString($setup.calculateCpiRate($setup.contract?.cpm?.amount, $setup.contract?.appliedFee)) + " " + _toDisplayString($setup.contract?.budget?.currency), 1),
              _hoisted_32,
              _createElementVNode("span", _hoisted_33, "Payout Cap: " + _toDisplayString($setup.calculateCpiRate($setup.contract?.cpm?.payoutCap, $setup.contract?.appliedFee)), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("span", _hoisted_37, _toDisplayString($setup.formatDate($setup.contract?.dates?.startDate)) + " - " + _toDisplayString($setup.formatDate($setup.contract?.dates?.endDate) || "Until Budget is Complete"), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("span", {
            class: "red-text",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({ name: 'campaign', params: { campaignID: _ctx.$route?.params?.campaignID } })))
          }, " view campaign details ")
        ])
      ])
    ]),
    _hoisted_40,
    _createElementVNode("div", _hoisted_41, [
      _createVNode(_component_submission_modal, {
        "error-channel": $setup.showBadChannelError,
        "show-modal": $setup.showSubmissionModal,
        "onUpdate:showModal": _cache[4] || (_cache[4] = ($event: any) => (($setup.showSubmissionModal) = $event)),
        onSave: $setup.postThroughModal
      }, null, 8, ["error-channel", "show-modal", "onSave"]),
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("div", _hoisted_43, [
          _hoisted_44,
          _hoisted_45,
          _hoisted_46,
          _createVNode(_component_Button, {
            label: "Upload Content",
            class: "red-button p-mt-4",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showSubmissionModal = true))
          }),
          _createVNode(_component_tracking_link, {
            user: $setup.user,
            contract: $setup.contract
          }, null, 8, ["user", "contract"]),
          _createElementVNode("div", {
            class: "red-text p-mt-5",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showTutorials = true))
          }, "WATCH A STEP BY STEP TUTORIAL")
        ])
      ])
    ]),
    _createVNode(_component_overlay_panel_modal, {
      show: $setup.showTutorials,
      "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => (($setup.showTutorials) = $event))
    }, null, 8, ["show"]),
    _hoisted_47,
    _createVNode(_component_DataTable, {
      value: $setup.latestSubmits,
      selection: $setup.selectContent,
      "onUpdate:selection": _cache[8] || (_cache[8] = ($event: any) => (($setup.selectContent) = $event)),
      responsiveLayout: "scroll",
      class: "p-mt-2 data-table"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          selectionMode: "single",
          field: "selected",
          header: ""
        }, {
          default: _withCtx(() => [
            _hoisted_48
          ]),
          _: 1
        }),
        _createVNode(_component_Column, { header: "CONTENT" }, {
          body: _withCtx((campaign) => [
            _createElementVNode("section", _hoisted_49, [
              _createElementVNode("img", {
                src: campaign.data.thumbnails.default.url
              }, null, 8, _hoisted_50)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "content link",
          header: "CONTENT LINK"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("span", _hoisted_52, _toDisplayString(data.url), 1),
              _createElementVNode("img", {
                src: _imports_3,
                class: "p-ml-2",
                onClick: ($event: any) => ($setup.copyLink(data.url))
              }, null, 8, _hoisted_53)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "STATUS",
          header: "Status"
        }, {
          body: _withCtx(() => [
            _createVNode(_component_status_chip, { status: 'active' })
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "submission date",
          header: "SUBMISSION DATE"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_54, _toDisplayString($setup.formatDate(data?.createdAt)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "views",
          header: "VIEWS"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("span", _hoisted_55, _toDisplayString(data?.statistics?.viewCount), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "selection"])
  ]))
}